import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminStudents() {
  const [students, setStudents] = useState([]);
  useEffect(() => { api.get("/admin/students").then((r) => setStudents(r.data)); }, []);

  return (
    <div className="space-y-4" data-testid="admin-students">
      <div className="rounded-3xl bg-card border border-border overflow-hidden">
        <div className="hidden md:grid grid-cols-[1fr_1fr_120px_100px] gap-4 px-5 py-3 text-xs uppercase tracking-widest text-muted-foreground border-b border-border">
          <span>Name</span><span>Email</span><span>Phone</span><span className="text-right">Points</span>
        </div>
        {students.map((s) => (
          <div key={s.id} className="grid md:grid-cols-[1fr_1fr_120px_100px] gap-4 items-center px-5 py-3.5 border-b border-border last:border-0">
            <div className="flex items-center gap-3">
              <div className="h-9 w-9 rounded-full royal-gradient text-white flex items-center justify-center text-xs font-bold">
                {s.name?.[0]?.toUpperCase() || "?"}
              </div>
              <p className="font-semibold text-sm">{s.name}</p>
            </div>
            <p className="text-sm text-muted-foreground truncate">{s.email}</p>
            <p className="text-sm text-muted-foreground">{s.phone || "—"}</p>
            <p className="text-sm text-gold font-semibold text-right">{s.points}</p>
          </div>
        ))}
        {students.length === 0 && <div className="p-6 text-center text-sm text-muted-foreground">No students yet.</div>}
      </div>
    </div>
  );
}
